
import * as account from './account'
import * as alipay from './alipay'
import * as captcha from './captcha'
import * as carousel from './carousel'
import * as collectionRecord from './collectionRecord'
import * as evaluation from './evaluation'
import * as file from './file'
import * as game from './game'
import * as gameTag from './gameTag'
import * as gameCategory from './gameCategory'
import * as menu from './menu'
import * as message from './message'
import * as notice from './notice'
import * as orderAccount from './orderAccount'
import * as permission from './permission'
import * as review from './review'
import * as role from './role'
import * as user from './user'


export default {
  account,
  alipay,
  captcha,
  collectionRecord,
  carousel,
  evaluation,
  file,
  game,
  gameTag,
  gameCategory,
  menu,
  message,
  notice,
  orderAccount,
  permission,
  review,
  role,
  user,
}
